<template>
    <div class="mb-5">
        <!-- Client Info -->
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-8">
                         <h5 class="card-title">
                            <span class="mdi mdi-access-point-network"></span> 
                            {{ clientData.client_name }}  ({{ clientData.location_name }})
                        </h5>
                        <p style="font-size: 1.2em;">Showing all tests for this client</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Test history -->
        <div class="card mt-3">
            <div class="card-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-8">
                        <h5 class="card-title">
                            <span class="mdi mdi-history text-muted"></span> Client Test History
                        </h5>
                    </div>
                </div>

                <!-- Loading info -->
                <div class="d-flex d-flex justify-content-center mt-5 mb-5" v-if="viewState == 'Busy'">
                    <b-spinner variant="secondary" style="width: 1.8rem; height: 1.8rem;"></b-spinner>
                </div>
                <!-- /Loading info -->  

                <div v-if="tests && tests.length == 0">
                    <p class="text-muted" style="font-size: 1.2em;">No tests recorded by {{ clientData.client_name }}</p>    
                </div>              
                
                <div v-if="tests && tests.length > 0 && viewState != 'Busy'">
                    <b-table ref="testDataTable"
                        striped hover small
                        selectable
                        select-mode="single"
                        class="mt-3"
                        @row-selected="onRowSelected"
                        :items="tests"
                        :fields="fields">
                        <template v-slot:cell(_vehicle)="data">                                
                            <span>{{ data.item.vehicle.manufacturer }} {{ data.item.vehicle.model }}</span>
                        </template>
                        <template v-slot:cell(_result)="data">
                            <div>
                                <span v-if="data.item.test_passed"><strong class="text-success">PASS</strong></span>
                                <span v-if="!data.item.test_passed"><strong class="text-danger">FAIL</strong></span>
                            </div>
                        </template>
                    </b-table>

                    <div class="row mt-4">
                        <div class="col">
                            <strong>{{ totalTests }}</strong> results
                            <span v-if="totalPages > 1">
                                | Page <strong>{{ pageNumber }}</strong> of <strong>{{ totalPages }}</strong> 
                            </span>
                        </div>
                        <div class="col" :style="totalPages == 1 ? 'display: none;' : ''">
                            <div class="float-right">
                                <button class="btn btn-success btn-sm mr-2" :disabled="pageNumber == 1" @click="previousPage">
                                    &laquo; Previous
                                </button>
                                <button class="btn btn-success btn-sm" :disabled="pageNumber == totalPages" @click="nextPage">
                                    Next &raquo;
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-if="viewState == 'Error'">
                    <div class="alert alert-danger mt-3">
                        Something went wrong loading your test data, please try again. 
                        If the problem persists, please contact our support team.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { TestService } from '../../services/testService'

    export default {
        props: {
            clientId: String,
            clientData: Object
        },
        data() {
            return {
                //clientData: {},
                viewState: 'Loading',
                tests: null,
                pageNumber: null,
                totalPages: null,
                pageSize: null,
                totalTests: null,
                error: null,
                fields: [
                    { key: 'time_start', label: 'Date Tested', formatter: (dt) => { return this.$moment(dt).format('DD/MM/YYYY HH:mm') } },
                    { key: 'location_name', label: 'Location' },
                    { key: 'test_type', label: 'Test Type' },
                    { key: 'vehicle.registration', label: 'Vehicle Reg.'},
                    { key: '_vehicle', label: 'Make/Model' }
                ]
            }
        },
        async mounted() {
            await this.loadTests(this.testPageSize, this.testPageNumber)
        },
        methods: {
            nextPage() {
                this.loadTests(this.testPageSize, this.pageNumber + 1)
            },
            previousPage() {
                this.loadTests(this.testPageSize, this.pageNumber - 1)
            },
            onRowSelected(items) {
                if (items.length > 0) {
                    this.$router.push({
                        name: 'test-details',
                        params: {
                            testId: items[0].test_id
                        }
                    })
                }
                this.$refs.testDataTable.clearSelected()
            },
            async loadTests(pageSize, pageNumber) {
                this.viewState = 'Busy'
                try {
                    let testsPage = await TestService.getVehicleTestsByClientIdPaged(this.clientId, pageSize, pageNumber)

                    this.pageNumber = testsPage.page
                    this.totalPages = testsPage.page_count
                    this.totalTests = testsPage.count
                    this.tests = testsPage.data
                    this.viewState = 'Idle'

                } catch (err) {
                    console.error('Error loading test results', err)
                    this.viewState = 'Error'
                    this.error = err
                }
            }
        }
    }
</script>
